import { useCallback } from "react";
import { UseFormGetValues } from "react-hook-form";
import { useVariants } from "../../hooks/useVariants";
import { FormValues } from "../../types/form";
import { mwcCartAPIURL, mwcGoodsNo } from "../../utils/cart";

interface ConfirmContainerProps {
  getValues: UseFormGetValues<FormValues>;
  parentCode: string | undefined;
}

export function useConfirm({ getValues, parentCode }: ConfirmContainerProps) {
  const [color, widthAndSize] = getValues(["color", "widthAndSize"]);
  const { variantData } = useVariants({
    colorValue: color,
    widthAndSize,
    parentCode: parentCode,
  });

  const onClickAddingToCart = useCallback(() => {
    if (variantData === undefined) throw new Error("variantDataが不正です");

    const leftGoodsNo = mwcGoodsNo({
      number: variantData.left.product.number,
      colorCode: variantData.left.color.order_code,
      sizeCode: variantData.left.size.order_code,
    });
    const rightGoodsNo = mwcGoodsNo({
      number: variantData.right.product.number,
      colorCode: variantData.right.color.order_code,
      sizeCode: variantData.right.size.order_code,
    });

    window.location.href = mwcCartAPIURL({
      leftGoodsNo,
      rightGoodsNo,
    });
  }, [variantData]);

  return {
    variantData,
    parentCode,
    onClickAddingToCart,
  };
}
